import { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../config/firebase';

export function useEmailCounts(user) {
  const [counts, setCounts] = useState({ inbox: 0, sent: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) {
      setCounts({ inbox: 0, sent: 0 });
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    const userEmailsRef = ref(database, `emails/${user.uid}`);
    
    // Use onValue for real-time updates
    const unsubscribe = onValue(
      userEmailsRef,
      (snapshot) => {
        try {
          const userEmails = snapshot.val() || {};
          const inboxEmails = userEmails.inbox || {};
          const sentEmails = userEmails.sent || {};
          
          setCounts({
            inbox: Object.keys(inboxEmails).length,
            sent: Object.keys(sentEmails).length
          });
          setLoading(false);
        } catch (err) {
          console.error('Error processing email counts:', err);
          setError(err.message);
          setCounts({ inbox: 0, sent: 0 });
          setLoading(false);
        }
      },
      (err) => {
        console.error('Error loading email counts:', err);
        setError(err.message);
        setCounts({ inbox: 0, sent: 0 });
        setLoading(false);
      }
    );

    // Cleanup: unsubscribe when component unmounts or user changes
    return () => {
      unsubscribe();
    };
  }, [user]);

  return { counts, loading, error };
}

